module.exports = __webpack_public_path__ + "img/vsHandCream2.da678ceb.jpg";